module.exports = __webpack_public_path__ + "img/install.55e58f8b.svg";